module.exports = __webpack_public_path__ + "static/media/(V)_MG_6310_-_Joias_Contenporaneas.73b644ca.jpg";